// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_3YUsx","tabs":"index_tabs_1_OFC"};